// extracted by mini-css-extract-plugin
export default {"player-pick":"jQB6Y37NLhDdeAeXvlKYfA==","tag":"mVL3Xj8Zkcb+T6+3UPEfJQ==","text":"SsCEd4-ASzzP+-xCNnybuQ=="};